import { Heading2, Heading3, Li, P, Strong, Ul } from '@ovotech/nebula';
import { AnalyticsRender } from '@ovotech/ui-tools';
import React, { FC } from 'react';
import {
  footnoteHomeRecoverPromo,
  getOfferFootnote,
} from '../../FooterTermsAndConditions';
import { FootnoteReferenced } from '@/src/components';
import { HOME_RECOVER_CARD } from '@/src/constants/analytics-subjects';
import { createHomeRecoverUrl } from '@/src/constants/endpoints';
import Offer from '@/src/pages/Offers/components/cards/Offer/Offer';
import image from '@/src/resources/offers/home-recover.jpg';
import { mqMediumUp } from '@/src/utils/mediaQuery';
import styled from 'styled-components';
import { dateToDayMonthYear } from '@/src/utils/date';
import { useHomeplanOffer } from '@/src/hooks/HomeServices/useHomeplanOffer';
import { formatDiscountPercentage } from './formatUtils';
interface HomeRecoverPromoOfferProp {
  accountId: string;
}

const Roundel = styled.div`
  ${({ theme: { colors } }) => `
  width: 115px;
  height: 115px;
  position: absolute;
  font-weight: 700;
  right: 5%;
  top: -28%;
  line-height:16px;
  border-radius: 50%;
  background-color: ${colors.green.energised};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${colors.green.midnight};
 
    ${mqMediumUp(`
      
      top: -20%;
    `)}
  `}
`;

const FreeMonthNumber = styled.h2`
  font-size: 42px;
  font-weight: 700;
  line-height: 42px;
  text-align: center;
`;

const FreeStong = styled(Strong)`
  font-weight: 900;
`;

export const HomeRecoverPromoOffer: FC<HomeRecoverPromoOfferProp> = ({
  accountId,
}) => {
  const {
    promotionDuration,
    promoEndDate,
    isOfferAvailable,
    maxDiscountPercentage,
    offerType,
    completeQuoteWithExcess,
  } = useHomeplanOffer({
    needsRepair: true,
  });

  const friendlyDateFormat =
    promoEndDate && dateToDayMonthYear(new Date(promoEndDate));

  return (
    <AnalyticsRender name={HOME_RECOVER_CARD}>
      <Offer
        image={image}
        linkUrl={createHomeRecoverUrl('homeRecover', accountId)}
        linkText={'Find out more'}
        offerId={'homeRecover'}
      >
        {isOfferAvailable && offerType === 'duration' && (
          <>
            <Heading3>
              Get a free repair and {promotionDuration} months{' '}
              {formatDiscountPercentage(maxDiscountPercentage)} on boiler cover{' '}
              <FootnoteReferenced
                content={getOfferFootnote(friendlyDateFormat)}
              />{' '}
              with Home Recover
            </Heading3>

            <Roundel>
              <FreeMonthNumber>{promotionDuration}</FreeMonthNumber>
              <span>
                months
                <br />
                <span>
                  <FreeStong>
                    {formatDiscountPercentage(maxDiscountPercentage)}
                  </FreeStong>
                </span>
              </span>
            </Roundel>
          </>
        )}

        {isOfferAvailable && offerType === 'discount' && (
          <>
            <Heading3>
              Get a free repair and {maxDiscountPercentage}% off on boiler cover{' '}
              <FootnoteReferenced
                content={getOfferFootnote(friendlyDateFormat)}
              />{' '}
              with Home Recover
            </Heading3>

            <Roundel>
              <FreeMonthNumber>{maxDiscountPercentage}%</FreeMonthNumber>
              <span>off</span>
            </Roundel>
          </>
        )}

        {!isOfferAvailable && (
          <Heading2>Get a free repair with Home Recover</Heading2>
        )}

        <P>
          Got an issue with your boiler, heating, plumbing, electrics or
          internal drains? As an OVO energy customer, you can get Home Recover
          <FootnoteReferenced content={footnoteHomeRecoverPromo} />, which
          includes:
        </P>
        <Ul>
          <Li>your upfront repair completed for free</Li>
          <Li>our most comprehensive cover plan</Li>
          <Li>an annual boiler service</Li>
        </Ul>
        <P>
          Plans start from £{completeQuoteWithExcess?.price?.contract.monthly} a
          month.
        </P>
      </Offer>
    </AnalyticsRender>
  );
};
